import { useCallback, useMemo } from 'react';

import { useProfile } from '@mint-lib/profile-helpers';

export type SuggestionVersion = typeof ALPHA_VERSION;
const ALPHA_VERSION = 'alpha' as const;

const useSuggestionVersion = () => {
  const { profileService } = useProfile();

  const isAlphaVersionEnabled = useMemo(
    () => profileService.getRelease()?.selectedVersion === 'v1',
    [profileService],
  );

  const addSuggestionVersion = useCallback(
    <T extends Record<string, unknown>>(
      data: T,
    ): T | (T & { version: SuggestionVersion }) =>
      isAlphaVersionEnabled ? { ...data, version: ALPHA_VERSION } : data,
    [isAlphaVersionEnabled],
  );

  return {
    isAlphaVersionEnabled,
    addSuggestionVersion,
  };
};

export default useSuggestionVersion;
